const initialState = {
  loading:false,
};

export function fetchFleetbackInterventions(state = initialState, action) {
  switch (action.type) {
    case 'FETCH.FLEETBACK_INTERVENTIONS.SUCCESS':
      return {
        ...state,
        payload: action.response.body,
      };
    default:
      return state
  }
}
